(() => {
  const selectors = {
    root: "[data-lgc-package-guide]",
    slide: "[data-package-guide-slide]",
    dot: "[data-package-guide-dot]",
    prev: "[data-package-guide-prev]",
    next: "[data-package-guide-next]",
  };

  const storagePrefix = "lgcPackageGuideIndex:";

  const getSectionId = (root) => {
    const sectionEl = root.closest('[id^="shopify-section-"]');
    return sectionEl ? sectionEl.id : "global";
  };

  const getStorageKey = (root) => `${storagePrefix}${getSectionId(root)}`;

  const loadStoredIndex = (root) => {
    try {
      const value = sessionStorage.getItem(getStorageKey(root));
      if (value === null) {
        return null;
      }

      const parsed = Number.parseInt(value, 10);
      return Number.isNaN(parsed) ? null : parsed;
    } catch (_) {
      return null;
    }
  };

  const storeIndex = (root, index) => {
    try {
      sessionStorage.setItem(getStorageKey(root), String(index));
    } catch (_) {
      /* empty */
    }
  };

  const findIndexByBlockId = (slides, blockId) => {
    if (!blockId) {
      return -1;
    }

    return slides.findIndex(
      (slide) =>
        slide.id === `shopify-block-${blockId}` ||
        slide.id.endsWith(blockId) ||
        slide.getAttribute("data-shopify-editor-block") === blockId
    );
  };

  const clampIndex = (value, length) => {
    if (!length) {
      return 0;
    }

    if (value < 0) {
      return length - 1;
    }

    if (value >= length) {
      return 0;
    }

    return value;
  };

  const initGuide = (root) => {
    if (!root || root.dataset.lgcPackageGuideInit === "true") {
      return;
    }

    const slides = Array.from(root.querySelectorAll(selectors.slide));
    const dots = Array.from(root.querySelectorAll(selectors.dot));
    const prevButton = root.querySelector(selectors.prev);
    const nextButton = root.querySelector(selectors.next);

    if (!slides.length) {
      return;
    }

    let activeIndex = Math.max(
      0,
      slides.findIndex((slide) => slide.classList.contains("is-active"))
    );

    const storedIndex = loadStoredIndex(root);
    if (storedIndex !== null) {
      activeIndex = clampIndex(storedIndex, slides.length);
    }

    const render = (index) => {
      activeIndex = clampIndex(index, slides.length);

      slides.forEach((slide, i) => {
        const isActive = i === activeIndex;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", String(!isActive));
      });

      dots.forEach((dot, i) => {
        const isActive = i === activeIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });

      if (prevButton) {
        prevButton.setAttribute("aria-label", `Go to step ${clampIndex(activeIndex - 1, slides.length) + 1}`);
      }

      if (nextButton) {
        nextButton.setAttribute("aria-label", `Go to step ${clampIndex(activeIndex + 1, slides.length) + 1}`);
      }

      storeIndex(root, activeIndex);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => render(index));
    });

    if (prevButton) {
      prevButton.addEventListener("click", () => render(activeIndex - 1));
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => render(activeIndex + 1));
    }

    root.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        render(activeIndex - 1);
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        render(activeIndex + 1);
      }
    });

    document.addEventListener("shopify:block:select", (event) => {
      const blockId = event.detail?.blockId;
      const selectedIndex = findIndexByBlockId(slides, blockId);
      if (selectedIndex >= 0) {
        render(selectedIndex);
      }
    });

    root.dataset.lgcPackageGuideInit = "true";
    render(activeIndex);
  };

  const initAllGuides = () => {
    document.querySelectorAll(selectors.root).forEach(initGuide);
  };

  document.addEventListener("DOMContentLoaded", initAllGuides);

  document.addEventListener("shopify:section:load", (event) => {
    if (!event.target) {
      return;
    }

    event.target.querySelectorAll(selectors.root).forEach(initGuide);
  });
})();
